import type { FC } from 'react'
import styled from '@emotion/styled'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

const copy = {
  heading: `Your customer data clarity awaits`,
  description: `When your data is sprawled across business units, products, and internal teams, your organization can’t trust it to make decisions or use it to serve your customers. It’s time to get your data together with Segment.`,
}

const Hero: FC = () => {
  return (
    <Wrapper>
      <StyledHeroBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pExtraLarge">
            {copy.description}
          </CopyText.Description>
          <HeroRecipe.Form>
            <StyledDemoForm isProgressive={true} customFormIdentifier="site-industry-ent-demo" />
          </HeroRecipe.Form>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <Picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x`} />
            <HeroRecipe.Image width="876" height="659" src={heroPng2x} alt="Hero" loading="lazy" />
          </Picture>
        </HeroRecipe.Contents>
      </StyledHeroBase>
    </Wrapper>
  )
}

const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    text-align: left;
  }
`

const StyledDemoForm = styled(DemoForm)`
  margin-top: 40px;
`

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default Hero
